(function () {
    "use strict";

    angular
        .module("app.sales")
        .factory("SalesPaymentService", SalesPaymentService);

    SalesPaymentService.$inject = ["$http", "$q"];

    function SalesPaymentService($http, $q) {
        var service = {
            payment: payment,
            getBanktype: getBanktype,
            getCurrency: getCurrency,
        };

        var serviceBase = "/";
        return service;

        function payment(pay) {
            var deferred = $q.defer();

            $http
                .post(serviceBase + "Checkout/Payment", pay, {
                    headers: {
                        "Content-Type":
                            "application/x-www-form-urlencoded;charset=utf-8;",
                    },
                })
                .then(paymentComplete)
                .catch(paymentFailed);

            function paymentComplete(response) {
                deferred.resolve(response.data);
            }

            function paymentFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }
        function getBanktype(cardNumber, totalPrice, isDirect) {
            var deferred = $q.defer();
            $http
                .get(
                    serviceBase +
                        "api/BankType/" +
                        cardNumber +
                        "?" +
                        "totalPrice=" +
                        totalPrice +
                        "&IsDirect=" +
                        isDirect
                )
                .then(getBanktypeComplete)
                .catch(getBanktypeFailed);

            function getBanktypeComplete(response) {
                deferred.resolve(response.data);
            }

            function getBanktypeFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }
        function getCurrency() {
            var deferred = $q.defer();

            $http
                .get(serviceBase + "api/GetAllCurrency")
                .then(getCurrencyComplete)
                .catch(getCurrencyFailed);

            function getCurrencyComplete(response) {
                deferred.resolve(response.data);
            }

            function getCurrencyFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }
    }
})();
